import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      redirect:'/index',
      component: index,
      meta: {
        keepAlive: false, // 不需要缓存
        title: '首页',
      }
      
    },
    {
      path:'/index',
      component:index,
      meta: {
        keepAlive: false, // 不需要缓存
        title: '首页',
      }
    },
    {
      path: '/AudioPlayer',
      name: 'AudioPlayer',
      component: (resolve) => require(['../components/AudioPlayer/AudioPlayer'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '播放页',
      }
    },
    {
      path: '/release',
      name: 'release',
      component: (resolve) => require(['../components/release/release'],resolve),
      meta: {
        keepAlive: true, // 需要缓存
        title: '发布',
      }
    },
    {
      path: '/auth',
      name: 'auth',
      component: (resolve) => require(['../components/auth'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '授权',
      }
    },
    {
      path: '/report',
      name: 'report',
      component: (resolve) => require(['../components/report/report'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '举报',
      }
    },
    {
      path: '/PictureCropping',
      name: 'PictureCropping',
      component: (resolve) => require(['../components/PictureCropping/PictureCropping'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '图片裁剪',
      }
    },
    {
      path: '/rewardList',
      name: 'rewardList',
      component: (resolve) => require(['../components/rewardList/rewardList'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '打赏记录',
      }
    },
    {
      path: '/PersonalCenter',
      name: 'PersonalCenter',
      component: (resolve) => require(['../components/PersonalCenter/PersonalCenter'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '个人中心',
      }
    },
    {
      path: '/HomepageSettings',
      name: 'HomepageSettings',
      component: (resolve) => require(['../components/HomepageSettings/HomepageSettings'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '主页设置',
      }
    },
    {
      path: '/income',
      name: 'income',
      component: (resolve) => require(['../components/income/income'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '我的收益',
      }
    },
    {
      path: '/Album',
      name: 'Album',
      component: (resolve) => require(['../components/Album/Album'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '音频专辑',
      }
    },
    {
      path: '/AlbumPay',
      name: 'AlbumPay',
      component: (resolve) => require(['../components/AlbumPay/AlbumPay'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '已购音频专辑',
      }
    },
    {
      path: '/IncomeBreakdown',
      name: 'IncomeBreakdown',
      component: (resolve) => require(['../components/IncomeBreakdown/IncomeBreakdown'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '收益明细',
      }
    },
    {
      path: '/WithdrawalRecord',
      name: 'WithdrawalRecord',
      component: (resolve) => require(['../components/WithdrawalRecord/WithdrawalRecord'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '提现记录',
      }
    },
    {
      path: '/Withdraw',
      name: 'Withdraw',
      component: (resolve) => require(['../components/Withdraw/Withdraw'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '提现',
      }
    },
    {
      path: '/addAlbum',
      name: 'addAlbum',
      component: (resolve) => require(['../components/addAlbum/addAlbum'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '专辑操作',
      }
    },
    {
      path: '/albumDetail',
      name: 'albumDetail',
      component: (resolve) => require(['../components/albumDetail/albumDetail'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '专辑详情',
      }
    },
    {
      path: '/Intellectual',
      name: 'Intellectual',
      component: (resolve) => require(['../components/Intellectual/Intellectual'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '知识产权',
      }
    },
    {
      path: '/voicePayList',
      name: 'voicePayList',
      component: (resolve) => require(['../components/voicePayList/voicePayList'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '已购音频',
      }
    },
    {
      path: '/BrowseList',
      name: 'BrowseList',
      component: (resolve) => require(['../components/BrowseList/BrowseList'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '浏览记录',
      }
    },
    {
      path: '/help',
      name: 'help',
      component: (resolve) => require(['../components/help/help'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '帮助中心',
      }
    },
    {
      path: '/ServiceAgreement',
      name: 'ServiceAgreement',
      component: (resolve) => require(['../components/ServiceAgreement/ServiceAgreement'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '服务协议',
      }
    },
    {
      path: '/helpDetails',
      name: 'helpDetails',
      component: (resolve) => require(['../components/helpDetails/helpDetails'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '帮助中心',
      }
    },
    {
      path: '/focusOn',
      name: 'focusOn',
      component: (resolve) => require(['../components/focusOn/focusOn'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '我的关注',
      }
    },
    {
      path: '/Fans',
      name: 'Fans',
      component: (resolve) => require(['../components/Fans/Fans'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '我的粉丝',
      }
    },
    {
      path: '/radar',
      name: 'radar',
      component: (resolve) => require(['../components/radar/radar'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '行为雷达',
      }
    },
    {
      path: '/raderList',
      name: 'raderList',
      component: (resolve) => require(['../components/raderList/raderList'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '行为雷达',
      }
    },
    {
      path: '/TotalRevenue',
      name: 'TotalRevenue',
      component: (resolve) => require(['../components/TotalRevenue/TotalRevenue'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '收益明细',
      }
    },
    {
      path: '/WithdrawList',
      name: 'WithdrawList',
      component: (resolve) => require(['../components/WithdrawList/WithdrawList'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '收益明细',
      }
    },
    {
      path: '/moreCoupon',
      name: 'moreCoupon',
      component: (resolve) => require(['../components/moreCoupon/moreCoupon'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '京东内购优惠券',
      }
    },
    {
      path: '/vipPay',
      name: 'vipPay',
      component: (resolve) => require(['../components/vipPay/vipPay'],resolve),
      meta: {
        keepAlive: false, // 不需要缓存
        title: '会员',
      }
    },
    
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js